import React, { useState } from 'react';
import {isMobile} from 'react-device-detect';
import MainTemplate from './MainTemplate';

function MobileOnly(props) {
    if (isMobile) {
        return (
            <>{props.children}</>
        )
    }
    return (
        <MainTemplate>
            <div className="d-flex justify-content-center my-5">
                <div className="py-5">
                    <h1>Mobile Only Page</h1>
                    <h6>Please visit this page on a mobile device</h6>
                </div>
            </div>
        </MainTemplate>
    );
}

export default MobileOnly;